import Vue from 'vue'
import Vuex from 'vuex'
import routerData from './modules/routerData'
import role from './modules/role'
import layout from './modules/layout/index'
import dic from './dic'
import queryPram from "./queryParam"
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    user: JSON.parse(localStorage.getItem('user')),
    token: localStorage.getItem('token')
  },
  mutations: {
    setToken (state, token) {
      state.token = token
      localStorage.setItem('token', token);
    },
    setUser (state, user) {
      state.user = user
      localStorage.setItem('user', JSON.stringify(user));
    }
  },
  actions: {
    setToken ({ commit }, token) {
      return new Promise((resolve, reject) => {
        commit('setToken', token)
        resolve()
      })
    },
    setUser ({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit('setUser', user)
        resolve()
      })
    }
  },
  getters: {
    addRouters: state => state.routerData.addRouters,
    token: state => state.token,
    user: state => state.user,
    rolenames: state => state.role.info,
    formLogin: state => state.role.formLogin,
    routers: state => state.routerData.routers,
    logoShow: state => state.layout.logoShow,
    isCollapse: state => state.layout.isCollapse,
    uniquerouter: state => state.layout.uniquerouter,
    tabnavBox: state => state.layout.tabnavBox,
    visible: state => state.layout.visible,
    left: state => state.layout.left,
    top: state => state.layout.top,
    rightNav: state => state.layout.rightNav,
  },
  modules: {
    routerData,
    role,
    layout,
    dic,
    queryPram
  }
})

export default store



// WEBPACK FOOTER //
// ./src/vuex/index.js